import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { JuvareLogo } from '../../JuvareLogo';
import { useCommonWebTranslation } from '../../hooks';
/**
 * Renders the Juvare icon button, which serves as a link to other Juvare solutions.
 * Wraps an icon in a tooltip and optionally handles click and navigation events.
 *
 * @param {object} props - Component properties.
 * @param {string} [props.href] - Optional URL to navigate to on click.
 * @param {() => void} [props.onClick] - Optional click handler for the icon button.
 * @returns {JSX.Element} The rendered Juvare icon button component.
 */
export const JuvareIconButton = (props) => {
    const { t } = useCommonWebTranslation();
    return (React.createElement(Tooltip, { title: t('globalHeader.otherJuvareSolutions') },
        React.createElement(IconButton, { size: 'large', href: props.href, onClick: props.onClick, "data-test": 'juvare-button' },
            React.createElement(Box, { sx: { width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                React.createElement(Box, { sx: { display: 'flex' } },
                    React.createElement(JuvareLogo, { size: 'lg' }))))));
};
